/**
 * ClaimsTabContainer.jsx
 *
 * Smart wrapper that subscribes to claims data only when the Claims tab
 * is rendered. When the tab is inactive, no detailed claims deserialization
 * occurs — the header uses the lightweight summary from meta.
 */

import React from 'react';
import ClaimsTab from './ClaimsTab';
import {useReferenceMarkData} from '../../../../hooks/useReferenceMarkData';

const CLAIMS_FIELDS = {fields: ['references', 'claims', 'suggestions']};

/**
 * @param {Object} props
 * @param {string} props.referenceMarkId
 * @param {Array}  props.sortedReferences  Already-sorted references from parent
 */
export default function ClaimsTabContainer({referenceMarkId}) {
    const {
        claims,
        references,
        summary,
        analysisLoading,
        extractionLoading,
        verificationLoading,
        suggestionsLoading,
        proofInsightsLoading,
        suggestedReferences,
        contradictions,
        extrinsicNotes,
    } = useReferenceMarkData(referenceMarkId, CLAIMS_FIELDS);

    return (
        <ClaimsTab
            analysisLoading={analysisLoading}
            extractionLoading={extractionLoading}
            verificationLoading={verificationLoading}
            suggestionsLoading={suggestionsLoading}
            proofInsightsLoading={proofInsightsLoading}
            summary={summary}
            claims={claims}
            references={references}
            suggestedReferences={suggestedReferences}
            contradictions={contradictions}
            extrinsicNotes={extrinsicNotes}
            referenceMarkId={referenceMarkId}
        />
    );
}

